var _path, _path2, _path3, _path4, _mask, _rect, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateGptApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 42,
    viewBox: "0 0 51 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4389 18.9126C42.7371 9.26329 36.3511 2.42106 24.1755 2C11.7733 2 1.71924 10.546 1.71924 21.0881C1.71924 31.6301 11.7733 40.1761 24.1755 40.1761C26.4903 40.1761 28.2457 39.9305 30.2458 39.2639",
    stroke: "#5F5FC4",
    strokeWidth: 3.15791,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3684 16.2471L31.4036 16.2471",
    stroke: "#5F5FC4",
    strokeWidth: 3.71932,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3684 25.2988L26.9825 25.2988",
    stroke: "#5F5FC4",
    strokeWidth: 3.71932,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03728 33.0908C5.90863 34.3306 5.49692 36.319 2.91445 37.7225C0.331973 39.126 8.5987 39.8629 11.4057 37.4067",
    stroke: "#5F5FC4",
    strokeWidth: 2.45615,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_42_12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.439,
    y: 29.7188,
    width: 16.8422,
    height: 12.2809,
    rx: 1.96492
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.439,
    y: 29.7188,
    width: 16.8422,
    height: 12.2809,
    rx: 1.96492,
    stroke: "#5F5FC4",
    strokeWidth: 7.15793,
    mask: "url(#path-5-inside-1_42_12)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2632 31.4386V27.2808C37.2632 26.7807 37.3225 26.2729 37.5756 25.8417C38.8805 23.6194 42.9611 21.3584 45.8672 25.4994C46.3207 26.1455 46.4913 26.9388 46.4913 27.7282V31.4386",
    stroke: "#5F5FC4",
    strokeWidth: 3.22809
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateGptApp);
export default __webpack_public_path__ + "static/media/private-gpt-app.56e826884639693777de29c6a7d450b6.svg";
export { ForwardRef as ReactComponent };